import { isMac } from '@wix/editor-elements-common-utils';

const keyMapping = {
  '2': {
    mac: ['2', '€', '™', '@'],
    windows: ['2', '²', '@', '€'],
  },
  '3': {
    mac: ['3', '£', '#', '³', '•'],
    windows: ['3', '³', '#', '£'],
  },
  '0': {
    mac: ['0', 'º', '°', 'ð'],
    windows: ['0', 'ø', '°'],
  },
  '7': {
    mac: ['7', '¶', '‡', '¬'],
    windows: ['7', '{', '¬'],
  },
  '8': {
    mac: ['8', '•', '™', '×'],
    windows: ['8', '[', '×'],
  },
  E: {
    mac: ['e', 'E', 'é', 'É', '€'],
    windows: ['e', 'E', 'é', 'É', '€'],
  },
  R: {
    mac: ['r', 'R', '®', '˜', '¶'],
    windows: ['r', 'R', '®'],
  },
  L: {
    mac: ['l', 'L', 'ì', 'Ì', 'ł', 'Ł'],
    windows: ['l', 'L', 'ł', 'Ł'],
  },
  J: {
    mac: ['j', 'J', '∆', 'Ô'],
    windows: ['j', 'J'],
  },
  K: {
    mac: ['k', 'K', '˚', '∫'],
    windows: ['k', 'K'],
  },
};

export function getPossibleKeys(key: keyof typeof keyMapping) {
  if (isMac()) {
    return keyMapping[key].mac;
  }
  return keyMapping[key].windows;
}
